import { inject, Injectable, signal } from '@angular/core';
import { ApiDataAccess, Result } from '@softline/core';
import { SOFTLINE_API_WWS_WARENUEBERNAHME_POSITION_ERLEDIGEN_MISCHPALETTEN } from '../warenuebernahme.api';
import { MischPalette } from '../types/misch-paletten';

@Injectable()
export class MischPalettenService {
  private readonly dataAccess = inject(ApiDataAccess);

  readonly isLoading = signal(false);

  async postionErledigenMischpaletten(idwu: number | string): Promise<Result<MischPalette[]>> {
    const location = {
      path: SOFTLINE_API_WWS_WARENUEBERNAHME_POSITION_ERLEDIGEN_MISCHPALETTEN,
      pathParams: { idwu },
    };

    return await this.dataAccess.get(location);
  }
}
